// Initialise Boomerang
if (typeof BOOMR !== "undefined" && BOOMR.init) {
  BOOMR.init({
    beacon_url: `${window.process.env.API_URL}/boomerang`,
    instrument_xhr: true,
    log: null,
  });
  BOOMR.addVar("env", window.process.env.INFRA_ENV);
}
